import * as React from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
// import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
// import { CgOrganisation } from 'react-icons/cg'
import { BsPersonCircle } from 'react-icons/bs'
import {  CiLogout } from 'react-icons/ci';
import './styles.css'
export default function AccountMenu(props) {
    // const organization = sessionStorage.getItem("org");
    // const contato = sessionStorage.getItem("nome");
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [organization] = React.useState(props.organization)
    const [contato] =  React.useState(props.contato)
    
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
   
    const logout = () => {
        sessionStorage.clear();
        window.location.reload()
    };
    const handleClose = () => {
        // logout()
        setAnchorEl(null);
    };
    
    return (
        <React.Fragment>
        <Box 
        // sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}
        >
            <Tooltip title={contato}>
            <button className='button-logout' type='button'
                onClick={handleClick}
                // size="small"
                // // sx={{ ml: 2 }}
                // aria-controls={open ? 'account-menu' : undefined}
                // aria-haspopup="true"
                // aria-expanded={open ? 'true' : undefined}
            >
                <Avatar sx={{ width: 28, height: 28 }} className='avatar'>{props.avatar}</Avatar>
            </button>
            </Tooltip>
        </Box>
        <Menu className='menu'
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleClose}
            
            PaperProps={{
            elevation: 0,
            sx: {
                overflow: 'visible',
                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                mt: 1.5,
                '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
                },
                '&:before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
                },
            },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
            {/* <MenuItem onClick={handleClose}> */}
            <div className='container-contato'>
                < BsPersonCircle className='person'/>
                <div className="organizacao">
                    <span>{organization}</span>
                </div>
                <div className="contato">
                    <span>{contato}</span>
                </div>
            
            </div>
            
            {/* </MenuItem> */}
            
            <Divider />
            <MenuItem onClick={logout}>
            <ListItemIcon>
                <CiLogout fontSize="20px" />
            </ListItemIcon>
            Logout
            </MenuItem>
        </Menu>
        </React.Fragment>
    );
}